import type { TranslationKeys } from './types';

const nl: TranslationKeys = {
  welcome: {
    close: 'Sluiten',
    tagline1: 'Maak je keuzes.',
    tagline2: 'Klim in het klassement.',
    tagline3: 'Win prijzen.',
    howToPlay: 'Hoe spelen',
    letsPlay: 'Spelen maar',
    altLogo: "Pick'em",
    altBrand: 'Circus Daily',
  },
  howToPlay: {
    back: 'Terug',
    title: 'Hoe spelen',
    demoQuestion: 'Wie wint de match?',
    demoTeamUsa: 'VS',
    demoTeamBelgium: 'België',
    step1Title: "Pick'Em",
    step1Description: 'Leg je voorspellingen vast voor de aftrap',
    step2Title: 'Scoor punten',
    step2Description: 'Elke juiste keuze levert je punten op',
    step3Title: 'Klop de concurrentie',
    step3Description: 'Doe beter dan vrienden en fans in het klassement',
    step4Title: 'Ga voor de glorie',
    step4Description: 'Win prijzen en het recht om op te scheppen',
    cta: 'Begrepen, spelen maar',
  },
  game: {
    status: {
      loading: 'Laden...',
      locked: 'Vergrendeld',
      live: 'LIVE',
      complete: 'Afgelopen',
      correct: 'juist',
    },
    actions: {
      edit: 'Bewerken',
      editPicks: 'Keuzes bewerken',
      viewPicks: 'Keuzes bekijken',
      playNow: 'Speel nu',
      leaderboard: 'Klassement',
      viewLeaderboard: 'Klassement',
      viewResults: 'Resultaten bekijken',
    },
    results: {
      rank: 'Plaats',
      totalPts: 'Totaal ptn',
    },
    labels: {
      start: 'Start:',
      picks: 'Keuzes:',
      firstPrize: '1e prijs:',
      vs: 'tegen',
      yes: 'Ja',
      no: 'Nee',
      free: 'GRATIS',
      prizePool: 'Prijzenpot:',
      prizePoolFallback: 'Prijzenpot',
      numPicks: 'aantal keuzes:',
      points: 'Punten:',
      rank: 'Plaats:',
      myPrize: 'Mijn prijs:',
    },
    time: {
      day: 'Dag',
      days: 'Dagen',
      hour: 'Uur',
      hours: 'Uur',
      soon: 'Binnenkort',
      startingSoon: 'Start binnenkort...',
    },
    contestClosed: 'Deze match is begonnen en dit spel is gesloten.',
    fallbackTitle: 'Competitie',
    fallbackTeam: 'Ploeg {{n}}',
    fallbackPlayer: 'Speler {{n}}',
    fallbackOption: 'Optie {{n}}',
    unknownPlayer: 'Onbekende speler',
    ordinals: {
      st: 'e',
      nd: 'e',
      rd: 'e',
      th: 'e',
    },
  },
  navigation: {
    filter: 'Filter',
    edit: 'Bewerken',
    chat: 'Chat',
    code: 'Code',
    mainNav: 'Hoofdnavigatie',
    backToLobby: 'Terug naar de lobby',
    leaderboard: 'Klassement',
  },
  actions: {
    clear: 'Wissen',
    quickPick: 'Snelle keuze',
    favouritePick: 'Favorieten',
    submitPicks: 'Verder om te bevestigen',
    submitMyPicks: 'Mijn keuzes indienen',
    editMyPicks: 'Mijn keuzes bewerken',
    submitting: 'Bezig met indienen...',
    confirmationTitle: 'Bevestiging',
    termsAgreement: 'Ik heb de spelvoorwaarden van Circus Daily gelezen en ga ermee akkoord',
    entryConfirmationMessage:
      'Bevestig je deelname aan dit spel. Je kan je keuzes nog bewerken tot de start van de eerste match.',
    updateSelections: 'Keuzes bijwerken',
    saveChanges: 'Wijzigingen opslaan',
    cancel: 'Annuleren',
    retry: 'Opnieuw proberen',
    goBack: 'Terug',
    tryAgain: 'Probeer opnieuw',
    reloadPage: 'Pagina herladen',
    close: 'Sluiten',
    back: 'Terug',
  },
  tabs: {
    lobby: 'Lobby',
    myPicks: 'Mijn keuzes',
    play: 'Spelen',
    recent: 'Recent',
    leaderboard: 'Klassement',
  },
  filter: {
    all: 'Alles',
  },
  leaderboard: {
    today: 'Vandaag',
    week: 'Week',
    season: 'Seizoen',
    daily: 'Dagelijks',
    monthly: 'Maandelijks',
    month: 'Maand',
    rank: 'Plaats',
    user: 'Gebruiker',
    player: 'Speler',
    points: 'Punten',
    prize: 'Prijs',
    pickem: 'Pickem',
    pickemLeaderboard: 'Pickem-klassement',
    close: 'Sluiten',
    scrollForMore: 'Scroll voor meer',
    loadMore: 'Meer laden',
    scrollToTop: 'Naar boven',
    failedToLoad: 'Klassement laden mislukt. Probeer het opnieuw.',
    noData: 'Geen klassementsgegevens voor deze periode.',
    absoluteWinner: 'Absolute winnaar - eerste juiste inzending',
    loading: 'Klassement laden...',
    loadingShort: 'Laden...',
    weekLabel: 'Week {{n}}',
    globalTitle: 'Algemeen klassement',
    noActive: 'Geen actief klassement',
    picksLoading: 'Keuzes laden...',
    noPicks: 'Geen keuzes beschikbaar',
    prizeDetails: 'Prijsdetails',
    crowns: 'Crowns',
    noSelection: 'Geen keuze',
    viewLeague: 'Klassement >',
    pickems: {
      loading: 'Pickems laden...',
      failed: 'Pickems laden mislukt.',
      empty: 'Geen pickems gevonden.',
    },
    weekly: {
      loading: 'Weekgegevens laden...',
      failed: 'Weekgegevens laden mislukt.',
      empty: 'Geen weekgegevens beschikbaar.',
    },
  },
  league: {
    settings: {
      title: 'INSTELLINGEN',
      showLeaderboards: 'Klassementen tonen',
      users: 'Gebruikers',
      usersCount: '{{count}} gebruikers',
      remove: 'Verwijderen',
      deleteGroup: 'Groep verwijderen',
      deleteConfirm: 'Deze league verwijderen?',
      deleteConfirmNamed: '"{{name}}" VERWIJDEREN?',
      deleteMessage: 'Alle vrienden worden uit het klassement verwijderd.',
      removePlayerConfirm: 'Deze speler verwijderen?',
      removePlayerConfirmNamed: '"{{name}}" VERWIJDEREN?',
      delete: 'Verwijderen',
      cancel: 'Annuleren',
      removePlayer: 'Speler verwijderen',
    },
  },
  pages: {
    gamesCount: 'Kies een spel',
    recentResults: 'Recente resultaten ({{count}})',
    noGamesAvailable: 'Geen actieve competities',
    noGamesAvailableSubtitle:
      'Er lopen momenteel geen competities. Kom binnenkort terug voor nieuwe spellen.',
    noCompletedGames: "Er zijn nog geen afgelopen PICK'EM-spellen.",
    noRecentResults: 'Geen recente resultaten',
    noRecentResultsSubtitle:
      'Afgelopen spellen van de laatste 7 dagen verschijnen hier. Ga naar de lobby om te spelen.',
    noPicksSubmitted: 'Geen keuzes ingediend',
    noPicksSubmittedSubtitle:
      'Je hebt momenteel geen keuzes om te spelen. Bekijk de nieuwste spellen in de lobby.',
    viewAvailableContests: 'Beschikbare spellen bekijken',
  },
  common: {
    picks: 'keuze{{plural}}',
    loading: 'Laden...',
    cancel: 'Annuleren',
    retry: 'Opnieuw proberen',
    goBack: 'Terug',
    back: 'Terug',
    close: 'Sluiten',
    error: 'Fout',
  },
  a11y: {
    contestViews: 'Spelweergaven',
    moreOptions: 'Meer opties',
    contestDetails: 'Speldetails',
    breadcrumb: 'Kruimelpad',
    scrollToTop: 'Naar boven',
    contestLogo: 'Spellogo',
    goBack: 'Ga terug',
    leagueIcon: 'League-icoon',
    progress: 'Voortgang: {{completed}} van {{total}}',
  },
  footer: {
    termsAndConditions: 'Algemene voorwaarden',
  },
  language: {
    label: 'Taal',
  },
  tiebreaker: {
    title: 'Schifting',
    defaultDescription: 'Voorspel de eindstand',
  },
  toast: {
    selectionsCleared: 'Je keuzes zijn gewist!',
    quickPicks: {
      title: 'Snelle keuzes gemaakt!',
      description: 'Er zijn willekeurige keuzes gemaakt voor alle vragen.',
    },
    popularPicks: {
      title: 'Populaire keuzes gemaakt!',
      description: 'Er zijn populaire keuzes gemaakt voor alle vragen.',
    },
    contestClosed: {
      title: 'Spel gesloten',
    },
    noSelections: {
      title: 'Geen keuzes',
      description: 'Maak minstens één keuze voor je opslaat.',
    },
    consentSaveFailed: {
      title: 'Toestemming opslaan mislukt',
      description: 'Probeer het opnieuw.',
    },
    submitSuccess: {
      title: 'Keuzes opgeslagen',
      description: 'Je keuzes zijn succesvol ingediend.',
    },
    submitError: {
      title: 'Keuzes opslaan mislukt',
      description: 'Er liep iets mis. Probeer het opnieuw.',
    },
  },
  modal: {
    picksSubmitted: {
      title: 'Keuzes ingediend',
      message: 'Je keuzes zijn opgeslagen.',
      editMessage: 'Bewerk ze wanneer je wil voor het spel begint.',
      returnToLobby: 'Mijn keuzes bekijken',
      likeYourPicks: 'Tevreden met je keuzes?',
      buildBetSlip: 'Maak een weddenschap van je keuzes.',
      youCouldWin: 'JE KAN WINNEN',
      fromBet: 'met een inzet van ${{amount}}',
      addToBetSlip: 'Aan wedbon toevoegen',
    },
    quickPick: {
      title: 'Snelle deelname',
      description:
        'We vullen je deelname met willekeurige keuzes. Je kan alles nog aanpassen tot de vergrendeling.',
      confirm: 'Keuzes willekeurig maken',
    },
    favouritePick: {
      title: 'Favoriete keuzes',
      description: 'Stel je deelname snel samen met de keuzes die andere spelers het vaakst maken.',
      confirm: 'Favorieten kiezen',
    },
    clearPicks: {
      title: 'Alle keuzes verwijderen',
      description:
        'Verwijder je huidige keuzes en begin opnieuw. Je kan nieuwe keuzes maken voor je je deelname indient.',
      confirm: 'Keuzes wissen',
    },
    clearSelections: {
      title: 'KEUZES WISSEN',
      confirm: 'Keuze wissen',
      cancel: 'Annuleren',
    },
    leagueCreated: {
      title: 'LEAGUE AANGEMAAKT!',
      pinMessage: 'Deel deze pincode met vrienden om je league te vervoegen.',
      copy: 'Kopiëren',
      share: 'Delen',
      viewLeague: 'League bekijken',
      shareTitle: 'Vervoeg mijn league!',
      shareText: 'Gebruik pincode {{pin}} om mijn league te vervoegen.',
    },
    contestDetails: {
      title: 'Speldetails',
      rulesError: 'Spelregels laden mislukt. Probeer het opnieuw.',
      howToPlay: 'Hoe spelen',
      dailyPrizes: 'Dagelijkse prijzen',
      monthlyPrizes: 'Maandelijkse prijzen',
      payout: {
        title: 'Prijzenverdeling',
        rank: 'Plaats',
        cash: 'Cash',
        crowns: 'Crowns',
      },
      fallback: {
        howToPlay1: 'Maak je keuzes voor het spel begint.',
        howToPlay2: 'Verdien punten voor elke juiste keuze.',
        howToPlay3: 'Klim in het klassement en win prijzen.',
        daily1: 'Dagelijkse prijzen worden toegekend op basis van je plaats.',
        monthly1: 'Maandelijkse prijzen worden op het einde van de maand toegekend.',
      },
    },
  },
  competition: {
    error: {
      notFound: 'Competitie niet gevonden',
    },
    ipBlocked: {
      title: 'Toegang beperkt',
      message:
        'Dit spel is enkel beschikbaar op Delta WiFi. Maak verbinding met Delta WiFi om verder te gaan.',
    },
  },
  errors: {
    toastTitle: 'Fout',
    network: 'Netwerkfout. Controleer je verbinding.',
    loginRequired: 'Meld je aan om verder te gaan.',
    forbidden: 'Je hebt geen toestemming om dit te bekijken.',
    invalidRequest: 'Ongeldige aanvraag. Controleer wat je hebt ingevuld.',
    server: 'Serverfout. Probeer het later opnieuw.',
    unexpected: 'Er is een onverwachte fout opgetreden.',
    occurred: 'Er is een fout opgetreden.',
    unableToConnect: 'Verbinden mislukt. Controleer je internetverbinding en probeer opnieuw.',
    sessionExpired: 'Je sessie is verlopen. Meld je opnieuw aan.',
    noPermission: 'Je hebt geen toestemming om dit te doen.',
    checkInput: 'Controleer wat je hebt ingevuld en probeer opnieuw.',
    serversIssues: 'Onze servers hebben problemen. Probeer het over enkele ogenblikken opnieuw.',
    generic: 'Er liep iets mis. Probeer het opnieuw.',
  },
  errorBoundary: {
    title: 'Er liep iets mis',
    description: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
    tryAgain: 'Probeer opnieuw',
    reloadPage: 'Pagina herladen',
  },
  app: {
    configError: {
      title: 'Configuratiefout',
      description: 'De app-configuratie kon niet geladen worden. Probeer het opnieuw.',
    },
    authFailed: {
      title: 'Aanmelden mislukt',
      clerkMissing: 'Aanmelden is niet geconfigureerd. Neem contact op met de ondersteuning.',
    },
  },
  auth: {
    callback: {
      completing: 'Aanmelden afronden…',
      pleaseWait: 'Even geduld…',
      failed: 'Aanmelden mislukt',
      missingToken: 'Aanmeldtoken ontbreekt.',
      returnHome: 'Terug naar start',
    },
    clerk: {
      signIn: 'Aanmelden',
      createAccount: 'Account aanmaken',
      alreadyHaveAccount: 'Heb je al een account?',
    },
  },
  marketingConsent: {
    headline: '$85.000 AAN PRIJZEN IN TOTAAL',
    subheadline: 'Gebrouwen voor legendarische overwinningen',
    checkboxPrompt:
      'Vink het vakje hieronder aan om exclusieve aanbiedingen, nieuws en updates van Modelo te ontvangen.',
    eligibilityText:
      "Deelnemers moeten 21+ zijn en inwoner van de Verenigde Staten/DC. Door op 'GRATIS SPELEN' te klikken bevestig ik dat ik 21 jaar of ouder ben en inwoner van de Amerikaanse staten/DC, en dat ik het officiële reglement heb gelezen en aanvaard.",
    footerText:
      '*Voor meer informatie over hoe DraftKings je gegevens verzamelt en gebruikt, lees je ons privacybeleid. Je kan het delen van je gegevens met Modelo stopzetten door te mailen naar privacy@cbrands.com.',
    buttonText: 'GRATIS SPELEN',
    brandFallback: 'Draft Kings',
    consentBodyBeforeLinks:
      'Ik geef DraftKings de opdracht om mijn e-mailadres met Modelo te delen en geef toestemming voor het gebruik van mijn persoonsgegevens voor marketing, analyse en gerichte reclame, inclusief het omzetten van mijn e-mailadres in identificatiegegevens, door Modelo en andere CBI-merken. Onderworpen aan Modelo’s',
    consentBodyBetweenLinks: 'en',
    consentBodyAfterLinks: '.',
    footerBeforePrivacy:
      '*Voor meer informatie over hoe DraftKings je gegevens verzamelt en gebruikt, lees je ons',
    footerAfterPrivacy:
      '. Je kan het delen van je gegevens met Modelo stopzetten door te mailen naar',
    privacyPolicy: 'Privacybeleid',
    privacyNotice: 'privacyverklaring',
    userAgreement: 'Gebruiksvoorwaarden van de website',
    a11y: {
      close: 'Marketingtoestemming sluiten',
      consentCheckbox: 'Toestemming om gegevens met Modelo te delen',
    },
  },
  prize: {
    crownsSuffix: 'c',
  },
  date: {
    tbd: 'Datum nog te bepalen',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    yesterday: 'Gisteren',
    days: '{{count}} dagen',
    daysAgo: '{{count}} dagen geleden',
    oneDayHyphen: '1 dag',
    daysHyphen: '{{count}} dagen',
  },
  friends: {
    challengeTitle: 'DAAG JE VRIENDEN UIT',
    challengeSubtitle: 'Maak een privéklassement voor jou en je vrienden!',
    joinLeague: 'Een league vervoegen',
    createLeague: 'Nieuwe league aanmaken',
    inviteHint: 'Een uitnodiging gekregen? Doe mee met de pincode die je ontving',
  },
  stats: {
    rushing_yards: 'Rushing yards',
    passing_yards: 'Passing yards',
    receptions: 'Receptions',
    receiving_yards: 'Receiving yards',
    touchdowns: 'Touchdowns',
    passing_touchdowns: 'Passing TD’s',
    rushing_touchdowns: 'Rushing TD’s',
    interceptions: 'Intercepties',
    fumbles: 'Fumbles',
    sacks: 'Sacks',
    tackles: 'Tackles',
    points: 'Punten',
    assists: 'Assists',
    rebounds: 'Rebounds',
    steals: 'Steals',
    blocks: 'Blocks',
    blocked_att: 'Geblokte pogingen',
    blocked_shots: 'Geblokte schoten',
    turnovers: 'Turnovers',
    three_points_made: 'Driepunters raak',
    three_points_att: 'Driepuntpogingen',
    three_points_pct: 'Driepunt-%',
    two_points_made: 'Tweepunters raak',
    two_points_att: 'Tweepuntpogingen',
    two_points_pct: 'Tweepunt-%',
    free_throws_made: 'Vrijworpen raak',
    free_throws_att: 'Vrijworppogingen',
    free_throws_pct: 'Vrijworp-%',
    field_goals_made: 'Veldgoals raak',
    field_goals_att: 'Veldgoalpogingen',
    field_goals_pct: 'Veldgoal-%',
    minutes: 'Minuten',
    offensive_rebounds: 'Aanvallende rebounds',
    defensive_rebounds: 'Verdedigende rebounds',
    personal_fouls: 'Persoonlijke fouten',
    plus_minus: 'Plus/min',
    double_doubles: 'Double-doubles',
    triple_doubles: 'Triple-doubles',
    goals: 'Doelpunten',
    runs: 'Runs',
    hits: 'Hits',
    home_runs: 'Homeruns',
    rbi: 'RBI’s',
    strikeouts: 'Strikeouts',
    soccer_goals: 'Doelpunten',
    soccer_assists: 'Assists',
    soccer_shots: 'Schoten',
    soccer_shots_on_target: 'Schoten tussen de palen',
    soccer_passes: 'Passes',
    soccer_pass_accuracy: 'Passnauwkeurigheid',
    soccer_tackles: 'Tackles',
    soccer_clearances: 'Ontzettingen',
    soccer_yellow_card: 'Gele kaarten',
    soccer_red_card: 'Rode kaarten',
    soccer_minutes_played: 'Gespeelde minuten',
    soccer_saves: 'Reddingen',
    soccer_corners: 'Hoekschoppen',
    soccer_fouls: 'Overtredingen',
    soccer_possession: 'Balbezit',
    soccer_team_goals: 'Doelpunten ploeg',
    soccer_team_shots: 'Schoten ploeg',
    soccer_team_shots_on_target: 'Schoten tussen de palen ploeg',
    soccer_team_yellow_cards: 'Gele kaarten ploeg',
    soccer_team_red_cards: 'Rode kaarten ploeg',
  },
  question: {
    over: 'Meer dan',
    under: 'Minder dan',
    selectPlayer: 'Kies een speler',
    selectTeam: 'Kies een ploeg',
    pick1Player: 'Kies 1 speler',
    pick1Team: 'Kies 1 ploeg',
    unknown: 'Onbekend',
  },
};

export default nl;
